<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Integración elegibilidad de transportación con SMTE+',
      routes: [
        'Inicio',
        'Reportes',
        'Integración elegibilidad de transportación con SMTE+',
      ],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          regions: [],
          services: [],
          status: [],
        },
        filters: {
          academicYear: null,
          region: null,
          service: null,
          statusPei: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          class: 'col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Región',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
        },
        {
          name: 'service',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Servicio',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.services,
          value: this.model.search.filters.service,
        },
        {
          name: 'statusPei',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus del PEI',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.status,
          value: this.model.search.filters.statusPei,
        },
      ]
    },
  },
  async mounted() {
    this.initFilters()
  },
  methods: {
    async initFilters() {
      await CodeApiServices.GetTransportationSmteParams().then(({ data }) => {
        this.model.search.collections.academicYears = data.academicYears
        this.model.search.collections.regions = data.regions
        this.model.search.collections.status = data.status
        this.model.search.collections.services = data.services
      })
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        this.process()
      }
    },
    async process() {
      if (this.model.search.filters.academicYear?.id) {
        await ReportServices.getReport('smteeligiblestudents', {
          academicYearId: this.model.search.filters.academicYear?.id,
          regionId: this.model.search.filters.region?.id,
          disciplineTypeId: this.model.search.filters.service?.id,
          peiStatusCode: this.model.search.filters.statusPei?.id,
        }).then((res) => DocumentServices.Download(res.data));
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
